import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { useTheme } from '../context/ThemeContext';

const NotFound: React.FC = () => {
  const { colors, dsColors } = useTheme();

  return (
    <div className="min-h-screen" style={{ backgroundColor: colors.background }}>
      <main className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-20 text-center">
        <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] mb-3" style={{ color: dsColors.treadGray }}>
          404
        </p>
        <h1 className="text-3xl sm:text-4xl font-bold mb-4" style={{ color: colors.textPrimary, textWrap: 'balance' }}>
          This road doesn't go anywhere
        </h1>
        <p className="text-base sm:text-lg mb-8" style={{ color: colors.textSecondary, textWrap: 'pretty' }}>
          The page you're looking for isn't here. It may have moved, or the link may be wrong.
        </p>
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <Link
            to="/"
            className="inline-flex items-center px-5 py-2.5 rounded-md text-sm font-semibold shadow-sm hover:shadow-md transition focus:outline-none focus-visible:ring-2"
            style={{
              backgroundColor: dsColors.primaryStrong,
              color: '#ffffff',
              '--tw-ring-color': dsColors.primary,
            } as React.CSSProperties}
          >
            Back to home
          </Link>
          <Link
            to="/help"
            className="inline-flex items-center px-5 py-2.5 rounded-md text-sm font-semibold transition focus:outline-none focus-visible:ring-2"
            style={{
              backgroundColor: colors.surface,
              color: colors.textPrimary,
              border: `1px solid ${colors.border}`,
              '--tw-ring-color': dsColors.primary,
            } as React.CSSProperties}
          >
            Browse Help
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
